'use strict';

var React = require('react');

var SvgSocialPostIcon = function SvgSocialPostIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.75c.414 0 .75.336.75.75v1.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.25c0-.414.336-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.03 4.78c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-1 1c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.75c0-1.795 1.455-3.25 3.25-3.25h4c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4c-2.623 0-4.75 2.127-4.75 4.75v.75c0 2.1 1.362 3.88 3.25 4.508v1.992c0 .283.16.542.413.67.252.127.556.101.783-.067l3.178-2.353h1.626c2.623 0 4.75-2.127 4.75-4.75 0-.414-.336-.75-.75-.75s-.75.336-.75.75c0 1.795-1.455 3.25-3.25 3.25h-1.873c-.161 0-.318.052-.447.147l-2.18 1.614v-1.081c0-.36-.256-.67-.61-.737-1.503-.285-2.64-1.607-2.64-3.193v-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.25c-.414 0-.75.336-.75.75s.336.75.75.75h5.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.25c0-.414.336-.75.75-.75h3.5c.414 0 .75.336.75.75s-.336.75-.75.75h-3.5c-.414 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75s.336.75.75.75h1.25Z"
  }));
};
SvgSocialPostIcon.displayName = "SocialPostIcon";

exports.SvgSocialPostIcon = SvgSocialPostIcon;
